// TUT-588a — tipos do Financeiro gerencial: categorias, centros de custo,
// orçamento e ajustes (espelham `apps/api/src/gerencial`).

export type TipoDeCategoria = "REVENUE" | "EXPENSE";
export type NaturezaDoCusto = "FIXED" | "VARIABLE";
export type GrupoDoDre =
  | "RECEITA_BRUTA"
  | "DEDUCOES"
  | "CUSTOS_DIRETOS"
  | "DESPESAS_ADMINISTRATIVAS"
  | "DESPESAS_COMERCIAIS"
  | "RESULTADO_FINANCEIRO";

/** A ordem do DRE: é a ordem dos grupos na tela. */
export const GRUPOS_DO_DRE: readonly GrupoDoDre[] = [
  "RECEITA_BRUTA",
  "DEDUCOES",
  "CUSTOS_DIRETOS",
  "DESPESAS_ADMINISTRATIVAS",
  "DESPESAS_COMERCIAIS",
  "RESULTADO_FINANCEIRO",
];

export const ROTULO_DO_GRUPO_DO_DRE: Record<GrupoDoDre, string> = {
  RECEITA_BRUTA: "Receita bruta",
  DEDUCOES: "Deduções",
  CUSTOS_DIRETOS: "Custos diretos",
  DESPESAS_ADMINISTRATIVAS: "Despesas administrativas",
  DESPESAS_COMERCIAIS: "Despesas comerciais",
  RESULTADO_FINANCEIRO: "Resultado financeiro",
};

export interface CategoriaGerencial {
  id: string;
  parentId: string | null;
  kind: TipoDeCategoria;
  name: string;
  dreGroup: GrupoDoDre;
  costNature: NaturezaDoCusto | null;
  systemKey: string | null;
  position: number;
  active: boolean;
}

export interface CentroDeCusto {
  id: string;
  name: string;
  description: string | null;
  systemKey: string | null;
  position: number;
  active: boolean;
}

/** `month` é o primeiro dia do mês (`AAAA-MM-01`). */
export interface LinhaDeOrcamento {
  month: string;
  categoryId: string;
  costCenterId: string;
  amountCents: number;
}

export interface AjustesFinanceiros {
  openingBalanceCents: number;
  openingBalanceDate: string | null;
  minMarginPercent: number;
  guideCompleted: boolean;
  guideCompletedAt: string | null;
}

export interface ConfiguracaoFinanceira {
  ano: number;
  settings: AjustesFinanceiros;
  categories: CategoriaGerencial[];
  costCenters: CentroDeCusto[];
  budgets: LinhaDeOrcamento[];
}

export interface CriarCategoriaInput {
  name: string;
  kind: TipoDeCategoria;
  dreGroup: GrupoDoDre;
  costNature?: NaturezaDoCusto | undefined;
  parentId?: string | undefined;
}

export interface MudarCategoriaInput {
  name?: string | undefined;
  dreGroup?: GrupoDoDre | undefined;
  costNature?: NaturezaDoCusto | undefined;
  parentId?: string | null | undefined;
  active?: boolean | undefined;
}

export interface CriarCentroInput {
  name: string;
  description?: string | undefined;
}

export interface MudarCentroInput {
  name?: string | undefined;
  description?: string | undefined;
  active?: boolean | undefined;
}

export interface MudarAjustesInput {
  openingBalanceCents?: number | undefined;
  openingBalanceDate?: string | null | undefined;
  minMarginPercent?: number | undefined;
}
